'use client';

import { usePageDataContextOptional } from '$/(cms)/_modules/cmsService/pageDataService/pageDataProvider';
import {
  formatDatePageTitle,
  getContentUpdatedDate,
  tr,
} from '$/components/cms/helpers';

/**
 * The "Updated: <date>" line every hero variant shows under its headline when
 * the block's `showTimestamp` is on: the page's content-update date. Undefined
 * when it is off, there is no page data (a host outside a page provider) or
 * the date does not parse.
 */
export const useFlexibleHeroBlockTimestamp = (
  showTimestamp: boolean | undefined,
  lang: string,
): string | undefined => {
  const { pageData } = usePageDataContextOptional() ?? {};
  const page = pageData?.page;
  const updatedAt =
    showTimestamp && page ? getContentUpdatedDate(page) : undefined;
  const date = updatedAt ? formatDatePageTitle(updatedAt, lang) : '';

  return date ? `${tr('updated', lang)}: ${date}` : undefined;
};
